import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type State = {
  isAceConnect: boolean;
};
const initialState: State = {
  isAceConnect: false,
};

const device = createSlice({
  name: 'aceConnect',
  initialState,
  reducers: {
    setIsAceConnect(state, { payload }: PayloadAction<boolean>) {
      state.isAceConnect = payload;
    },
  },
});

export const { setIsAceConnect } = device.actions;
// export const selectedIsAceConnect = (state: RootState) => state.aceConnect.isAceConnect;

export default device.reducer;
